module.exports = __webpack_public_path__ + "static/img/bottom3.1fffb64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottom3.png
// module id = +w2y
// module chunks = 1